var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvertedCommasSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.73,
    height: 19.745,
    viewBox: "0 0 23.73 19.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_239612",
    "data-name": "Path 239612",
    d: "M24.2-39.557q0,6.607-6.284,11.1a4.527,4.527,0,0,1-2.19,1.077q-.5,0-.5-.628a1.556,1.556,0,0,1,.2-.9,2.326,2.326,0,0,1,.485-.485q.287-.215.575-.4a5.039,5.039,0,0,0,.682-.539q3.519-3.016,3.519-5.889,0-1.544-1.257-1.544-5.279,0-5.279-4.345a3.7,3.7,0,0,1,1.293-2.855,4.147,4.147,0,0,1,2.837-1.167,5.03,5.03,0,0,1,4.381,2.208A7.6,7.6,0,0,1,24.2-39.557Zm-12.712,0q0,6.715-6.1,10.988a4.2,4.2,0,0,1-2.155,1.185q-.718,0-.718-.628a1.465,1.465,0,0,1,.2-.88,3.09,3.09,0,0,1,.485-.485,5.727,5.727,0,0,1,.575-.413,3.822,3.822,0,0,0,.646-.539q3.627-3.232,3.627-5.889,0-1.544-1.329-1.544-5.243,0-5.243-4.309a3.8,3.8,0,0,1,1.275-2.855,4.061,4.061,0,0,1,2.855-1.2,5.034,5.034,0,0,1,4.327,2.173A7.481,7.481,0,0,1,11.491-39.557Z",
    transform: "translate(-0.972 46.628)",
    fill: "#d7b16d",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedCommasSvg);
export default __webpack_public_path__ + "static/media/inverted-commas-svg.4ad645e1d33848b2588b21f3d1d9ac52.svg";
export { ForwardRef as ReactComponent };